<template>
	<div class="content">
		<base-header class="pb-6">
			<div class="row align-items-center py-4">
				<div class="col-lg-6 col-7">
					<h6 class="h2 text-white d-inline-block mb-0">{{ $t("pos.menu.events") }}</h6>
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</div>
				<div class="col-lg-6 col-5 text-right">
					<base-button size="md" type="neutral" @click="$router.push({ name: 'PosEventForm', params: { id: 'new' } })">{{ $t("pos.event.add") }}</base-button>
				</div>
			</div>
		</base-header>

		<div class="container-fluid mt--6">
			<pos-install-alert :show="notInstalled"></pos-install-alert>
			<!-- table edge-to-edge in the card (as /backoffice/orders-overview): card body px-0, everything else in px-4 -->
			<card class="no-border-card" body-classes="px-0 pb-1">
				<div class="px-4">
					<div class="row mb-2">
						<div class="col-md-3 col-6">
							<el-select v-model="status" class="w-100" @change="load">
								<el-option :label="$t('pos.filter.status_all')" value=""></el-option>
								<el-option :label="$t('pos.common.active')" value="1"></el-option>
								<el-option :label="$t('pos.common.inactive')" value="0"></el-option>
							</el-select>
						</div>
						<div class="col-md-4 col-6">
							<el-input v-model="q" clearable :placeholder="$t('pos.common.search')" @keyup.enter.native="load" @clear="load"></el-input>
						</div>
					</div>
				</div>
				<el-table :data="rows" v-loading="loading" header-row-class-name="thead-light" class="bon-table pos-table pos-click-rows" @row-click="(r) => $router.push({ name: 'PosEventForm', params: { id: r.id } })">
					<el-table-column :label="$t('pos.event.name')" prop="name" min-width="200"></el-table-column>
					<el-table-column :label="$t('pos.event.location')" prop="location" min-width="140"></el-table-column>
					<el-table-column :label="$t('pos.event.date_range')" min-width="190">
						<template slot-scope="{ row }">{{ row.start_date }} – {{ row.end_date }}</template>
					</el-table-column>
					<el-table-column :label="$t('pos.event.status')" min-width="190">
						<template slot-scope="{ row }">
							<el-tag :type="row.status === 1 ? 'success' : 'info'" size="small" class="mr-1">{{ row.status === 1 ? $t("pos.common.active") : $t("pos.common.inactive") }}</el-tag>
							<el-tag v-if="row.active_today" type="warning" size="small">{{ $t("pos.event.active_today") }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column :label="$t('pos.event.devices')" prop="device_count" width="80" align="right"></el-table-column>
					<el-table-column :label="$t('pos.event.products')" prop="product_count" width="80" align="right"></el-table-column>
					<el-table-column :label="$t('pos.event.bundles')" prop="bundle_count" width="90" align="right"></el-table-column>
					<el-table-column :label="$t('pos.event.bills')" prop="bill_count" width="80" align="right"></el-table-column>
				</el-table>
			</card>
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Tag, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { PosService } from "@/resource";
import posPageMixin from "./posPageMixin";
import PosInstallAlert from "./PosInstallAlert.vue";

export default {
	name: "PosEvents",
	mixins: [posPageMixin],
	components: { RouteBreadCrumb, PosInstallAlert, [Table.name]: Table, [TableColumn.name]: TableColumn, [Tag.name]: Tag, [Select.name]: Select, [Option.name]: Option },
	data() {
		return { rows: [], status: "", q: "" };
	},
	mounted() {
		this.load();
	},
	activated() {
		this.load();
	},
	methods: {
		async load() {
			this.loading = true;
			try {
				const p = {};
				if (this.status !== "") p.status = this.status;
				if (this.q.trim()) p.q = this.q.trim();
				const res = await PosService.PosEventList(p);
				this.rows = (res.data && res.data.Data) || [];
				this.notInstalled = false;
			} catch (err) {
				this.rows = [];
				this.posError(err);
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>

<style>
.pos-click-rows .el-table__row {
	cursor: pointer;
}
</style>
